import type { UseOverlayScrollbarsParams } from 'overlayscrollbars-react';
import { useOverlayScrollbars } from 'overlayscrollbars-react';
import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';
import { Box } from '#core/components';

import './styles.css';

export type ScrollbarsProps = UseOverlayScrollbarsParams & {
  children?: React.ReactNode;
};

type Props = ScrollbarsProps & {
  viewportRef: RefObject<HTMLDivElement | null>;
};

export const Scrollbars = ({ viewportRef, children, ...rest }: Props) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [initialize, instance] = useOverlayScrollbars({
    options: {
      ...rest.options,
      scrollbars: {
        autoHide: 'scroll',
        autoHideDelay: 1000
      }
    },
    ...rest
  });

  useEffect(() => {
    if (viewportRef.current && targetRef.current) {
      initialize({
        target: targetRef.current,
        elements: {
          viewport: viewportRef.current
        }
      });
    }

    return () => {
      instance()?.destroy();
    };
  }, [initialize, instance, viewportRef]);

  return (
    <Box data-overlayscrollbars-initialize h="100%" ref={targetRef}>
      {children}
    </Box>
  );
};
